import { type IstanzaSezioneDati } from '@framework/api-client/api/backoffice/schemas/istanzaSezioneDati.ts';
import { type AnagraficaDTO } from '@framework/api-client/api/inquiries/schemas/anagraficaDTO.ts';
import { type IEngineRawSemanticField } from '@framework/common-web/engine/engine-validation/IEngineRawSemanticField.ts';
import { type IEngineValidationContextParams } from '@framework/common-web/engine/engine-validation/IEngineValidationContext.ts';
import { useEngineValidationContext } from '@framework/common-web/engine/engine-validation/useEngineValidationContext.ts';
import { ProcedureDeclarationSection } from '@framework/common-web/schema/declarations/ProcedureDeclarationSection.tsx';
import { useProcedureInitialValues } from '@framework/common-web/schema/procedure/hooks/useProcedureInitialValues.ts';
import { useProcedureSchema } from '@framework/common-web/schema/procedure/hooks/useProcedureSchema.ts';
import {
  VALIDATION_TYPE,
  ValidationType,
} from '@framework/engine/validator/form-builder/types/FormBuilderTypes.ts';
import { FormCoordinator } from '@framework/form/form/coordinator/FormCoordinatorContext.tsx';
import { FormHandler } from '@framework/form/form/FormHandler.tsx';
import { useMemo } from 'react';

export interface IDossierDataTabProps {
  id: string;
  sections: IstanzaSezioneDati[];
  registers: AnagraficaDTO[] | null | undefined;
  dossierSemanticFields: IEngineRawSemanticField[] | undefined;
}

/**
 * Tab di dettaglio della pratica (sezioni dati precompilate)
 */
export function DossierDataTab(props: IDossierDataTabProps) {
  const { id, sections, dossierSemanticFields, registers } = props;

  const validationContextParams: IEngineValidationContextParams = useMemo(
    () => ({
      user: null,
      registers,
      dossierSemanticFields,
      semanticFields: dossierSemanticFields,
      // Catalogo dei tag non disponibile: nessun merge live dei campi semantici
      semanticTags: null,
      applicant: null,
      attorney: null,
      submission: null,
      submissionModule: null,
      others: { [VALIDATION_TYPE]: ValidationType.COMPLETE },
      externalServiceContext: null,
      trustedEnvironment: false,
      isIntegration: false,
    }),
    [registers, dossierSemanticFields],
  );

  const validationContext = useEngineValidationContext(validationContextParams);

  // Costruisco lo schema di validazione. Anche se il form è readonly,
  // è necessario costruire lo schema per poter utilizzare le logiche
  // di visibilità condizionale dei campi.
  const schema = useProcedureSchema({ declarations: sections });

  const initialValues = useProcedureInitialValues({
    declarations: sections,
    schema,
    validationContext,
  });

  return (
    <FormCoordinator>
      <FormHandler
        id={id}
        schema={schema}
        validationContext={validationContext}
        initialValues={initialValues}
        onSubmit={() => {}}
      >
        {sections.map(d => (
          <ProcedureDeclarationSection
            declaration={d}
            key={d.codiceSezioneDati}
          />
        ))}
      </FormHandler>
    </FormCoordinator>
  );
}
